import React, {useEffect, useRef} from 'react';
import styles from './BulkBar.module.css';

const CloseIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" aria-hidden="true" {...props}>
        <path d="M6 6l12 12M18 6L6 18"/>
    </svg>
);

// Floating dark bar shown once at least one row is selected.
const BulkBar = ({count, onMove, onDelete, onClear}) => {
    const announceRef = useRef(null);

    useEffect(() => {
        if (announceRef.current) {
            announceRef.current.textContent = `${count} selected`;
        }
    }, [count]);

    if (count === 0) return null;

    return (
        <div role="toolbar" aria-label={`${count} selected`} className={styles.bar}>
            <span className={styles.count}>{count} selected</span>
            <span ref={announceRef} aria-live="polite" className={styles.srOnly}/>
            <div className={styles.actions}>
                {onMove && <button type="button" className={styles.action} onClick={onMove}>Move</button>}
                <button type="button" className={styles.deleteAction} onClick={onDelete}>Delete</button>
                <button type="button" aria-label="Clear selection" className={styles.clear} onClick={onClear}>
                    <CloseIcon/>
                </button>
            </div>
        </div>
    );
};

export default BulkBar;
